import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_PH_UQ || "uq.ph.new-styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_PH_UQ || 27465,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_PH_UQ || 27466,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_PH_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_PH_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_PH_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_PH_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: false,
  languages: [LANGUAGE.EN],
  countryRegion: "Asia/Manila",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "PHT",
      offset: {
        PHT: 8
      }
    }
  },
  dateFormat: {
    [LANGUAGE.EN]: "<MM>/<DD>/<yyyy>"
  },
  requireDecimal: false
};

export default _countryEnv;
